
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

interface TaskCardContainerProps {
  isDeleting: boolean;
  isDragging: boolean;
  children: React.ReactNode;
}

const TaskCardContainer = ({ isDeleting, isDragging, children }: TaskCardContainerProps) => {
  return (
    <motion.div
      initial={{ opacity: 0.9 }} /* Start more visible to prevent the teleport effect */
      animate={isDeleting 
        ? { opacity: 0, height: 0, marginBottom: 0 } 
        : { opacity: 1, scale: isDragging ? 1 : 1 } // Removed scale during drag to prevent conflicts
      }
      exit={{ opacity: 0 }}
      transition={{ 
        duration: isDragging ? 0 : 0.2, // Disable transitions during drag to prevent conflicts with DnD-kit
        type: 'tween',
        ease: 'easeOut'
      }}
      style={isDragging ? { transform: 'none' } : undefined} // Disable Framer Motion transforms during drag
      className={cn(
        !isDragging && "transition-all duration-300 ease-in-out", // Only apply CSS transitions when not dragging
        isDragging ? "shadow-lg opacity-40 pointer-events-none" : ""
      )}
    >
      {children}
    </motion.div>
  );
};

export default TaskCardContainer;
